module.exports = __webpack_public_path__ + "static/media/customer-image.7a3cb932.webp";